// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InternationalCollaboratorMap_container__-24BC {
  position: relative;
  background-color: #f5f7fa;
}
.InternationalCollaboratorMap_container__-24BC .InternationalCollaboratorMap_loading__5API9 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 1;
}
.InternationalCollaboratorMap_container__-24BC .InternationalCollaboratorMap_chart__\\+MW3b {
  width: 100%;
  height: 100%;
}
.InternationalCollaboratorMap_container__-24BC .InternationalCollaboratorMap_hover-cover__8en3c {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: transparent;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  color: transparent;
  transition: all 0.2s;
  cursor: pointer;
}
.InternationalCollaboratorMap_container__-24BC .InternationalCollaboratorMap_hover-cover__8en3c:hover {
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
}
.InternationalCollaboratorMap_container__-24BC .InternationalCollaboratorMap_keyword-search__XAwBp {
  width: 50%;
  position: absolute;
  top: 16px;
  left: 16px;
  background-color: rgba(255, 255, 255, 0.7);
  padding: 6px;
  z-index: 1;
  display: flex;
  align-items: flex-start;
  gap: 12px;
}
.InternationalCollaboratorMap_container__-24BC .InternationalCollaboratorMap_keyword-search__XAwBp.InternationalCollaboratorMap_hidden__sqoyg {
  display: none;
}

.InternationalCollaboratorMap_modal__l\\+iiH {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80dvw;
  height: 80dvh;
  background-color: white;
}
.InternationalCollaboratorMap_modal__l\\+iiH .InternationalCollaboratorMap_close-button__jbzht {
  display: none;
}

@media only screen and (max-width: 480px) {
  .InternationalCollaboratorMap_container__-24BC .InternationalCollaboratorMap_chart__\\+MW3b {
    height: calc(100% - 22px);
  }
  .InternationalCollaboratorMap_modal__l\\+iiH {
    width: 100dvw;
    height: 100dvh;
  }
  .InternationalCollaboratorMap_modal__l\\+iiH .InternationalCollaboratorMap_close-button__jbzht {
    display: block;
    position: absolute;
    top: 16px;
    right: 16px;
    z-index: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Components/InternationalCollaboratorMap/InternationalCollaboratorMap.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,yBAAA;AACF;AACE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,oCAAA;EACA,UAAA;AACJ;AAEE;EACE,WAAA;EACA,YAAA;AAAJ;AAGE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,eAAA;AADJ;AAGI;EACE,oCAAA;EACA,YAAA;AADN;AAKE;EACE,UAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,0CAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;AAHJ;AAKI;EACE,aAAA;AAHN;;AAQA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;AALF;AAOE;EACE,aAAA;AALJ;;AASA;EAEI;IACE,yBAAA;EAPJ;EAWA;IACE,aAAA;IACA,cAAA;EATF;EAWE;IACE,cAAA;IACA,kBAAA;IACA,SAAA;IACA,WAAA;IACA,UAAA;EATJ;AACF","sourcesContent":[".container {\n  position: relative;\n  background-color: #f5f7fa;\n\n  .loading {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: rgba($color: #000000, $alpha: 0.2);\n    z-index: 1;\n  }\n\n  .chart {\n    width: 100%;\n    height: 100%;\n  }\n\n  .hover-cover {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: transparent;\n    z-index: 1;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: transparent;\n    transition: all 0.2s;\n    cursor: pointer;\n\n    &:hover {\n      background-color: rgba($color: #000000, $alpha: 0.6);\n      color: white;\n    }\n  }\n\n  .keyword-search {\n    width: 50%;\n    position: absolute;\n    top: 16px;\n    left: 16px;\n    background-color: rgba($color: #ffffff, $alpha: 0.7);\n    padding: 6px;\n    z-index: 1;\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n\n    &.hidden {\n      display: none;\n    }\n  }\n}\n\n.modal {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 80dvw;\n  height: 80dvh;\n  background-color: white;\n\n  .close-button {\n    display: none;\n  }\n}\n\n@media only screen and (max-width: 480px) {\n  .container {\n    .chart {\n      height: calc(100% - 22px);\n    }\n  }\n\n  .modal {\n    width: 100dvw;\n    height: 100dvh;\n\n    .close-button {\n      display: block;\n      position: absolute;\n      top: 16px;\n      right: 16px;\n      z-index: 1;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `InternationalCollaboratorMap_container__-24BC`,
	"loading": `InternationalCollaboratorMap_loading__5API9`,
	"chart": `InternationalCollaboratorMap_chart__+MW3b`,
	"hover-cover": `InternationalCollaboratorMap_hover-cover__8en3c`,
	"keyword-search": `InternationalCollaboratorMap_keyword-search__XAwBp`,
	"hidden": `InternationalCollaboratorMap_hidden__sqoyg`,
	"modal": `InternationalCollaboratorMap_modal__l+iiH`,
	"close-button": `InternationalCollaboratorMap_close-button__jbzht`
};
export default ___CSS_LOADER_EXPORT___;
